<template>
  <div id="header">
    <!-- <div class="headPC">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
        <img class="logo-image" :src="logosrc">
        <el-menu-item index="1" class="el-menu-item-home"><a href="javascript:;" @click="home" data-nav="1">首页</a></el-menu-item>
        <el-submenu index="2" class="el-submenu el-menu-item">
          <template class="el-template-solution" slot="title"><a href="javascript:;" @click="solution" data-id="1" data-name="解决方案" data-nav="2">解决方案</a></template>
          <el-menu-item index="2-1" v-for="(item,index) in solutionCateList" :key="index"><a href="javascript:;" @click="solution" :data-id="item.id" :data-name="item.name">{{item.name}}</a></el-menu-item>
        </el-submenu>
        <el-submenu index="3" class="el-submenu el-menu-item">
          <template slot="title"><a @click="service" data-service="technical_service" data-nav="3">服务支持</a></template>
          <el-menu-item index="3-1"><a href="javascript:;" @click="service" data-service="technical_service" data-nav="3">技术服务</a></el-menu-item>
          <el-menu-item index="3-2"><a href="javascript:;" @click="service" data-service="consulting_service" data-nav="3">咨询服务</a></el-menu-item>
          <el-menu-item index="3-3"><a href="javascript:;" @click="service" data-service="maintenance_service" data-nav="3">维保服务</a></el-menu-item>
        </el-submenu>
        <el-menu-item index="4"><a href="javascript:;" @click="cases" data-nav="4">客户案例</a></el-menu-item>
        <el-menu-item index="5"><a href="javascript:;" @click="partner" data-nav="5">合作伙伴</a></el-menu-item>
        <el-menu-item index="6"><a href="javascript:;" @click="news" data-nav="6">千界资讯</a></el-menu-item>
        <el-submenu index="7" class="el-submenu el-menu-item">
          <template slot="title"><a href="javascript:;" @click="about" data-nav="7">关于我们</a></template>
          <el-menu-item index="7-1"><a href="javascript:;" @click="about" data-nav="7">公司简介</a></el-menu-item>
          <el-menu-item index="7-2"><a href="javascript:;" @click="contact" data-nav="7">联系我们</a></el-menu-item>
          <el-menu-item index="7-3"><a href="javascript:;" @click="join" data-nav="7">加入我们</a></el-menu-item>
        </el-submenu>
      </el-menu>
    </div> -->
    <!-- pc头部 -->
    <div class="headPC">
      <div class="content">
        <a href="./" class="logo">
          <img :src="img_url + configList.pc_logo" alt="logo">
        </a>
        <div class="headPCnav">
          <div class="wrapper">
            <nav id="booNavigation" class="booNavigation">
              <ul>
                <li :class="[activeIndex == 1?'navItem on':'navItem']">
                  <a href="./" title="First Item">首页</a>
                </li>
                <li :class="[activeIndex == 2?'navItem on':'navItem']">
                  <a href="javascript:;" title="Second Item" @click="service" data-id="1" data-name="产品服务" data-nav="2">产品服务</a>
                  <ul class="navContent">
                    <li v-for="(item,index) in solutionCateList" :key="index">
                      <ul>
                        <li><a class="second-a" href="javascript:;" @click="service" :data-id="item.id" :data-name="item.name" data-nav="2">
                          <div class="navigation-title">{{item.name}}</div>
                          <div class="navigation-brief">{{item.brief}}</div>
                        </a></li>
                        <!-- <li><a href="javascript:;">&gt;&nbsp;超融合 HCI</a></li> -->
                      </ul>
                    </li>
                  </ul>
                </li>
                <li :class="[activeIndex == 3?'navItem on':'navItem']">
                  <a href="javascript:;" title="Third Item" @click="solution" data-id="26" data-service="technical_service" data-nav="3">解决方案</a>
                  <ul class="navContent">
                    <li v-for="(item,index) in cateList" :key="index">
                      <ul>
                        <li><a class="second-a" href="javascript:;" @click="solution" :data-id="item.id" :data-name="item.name" data-nav="2">
                          <div class="navigation-title">{{item.name}}</div>
                          <div class="navigation-brief">{{item.brief}}</div>
                        </a></li>
                        <!-- <li><a href="javascript:;">&gt;&nbsp;超融合 HCI</a></li> -->
                      </ul>
                    </li>
                  </ul>
                </li>
                <li :class="[activeIndex == 4?'navItem on':'navItem']">
                  <a href="javascript:;" title="Third Item" @click="join" data-nav="4">人才招聘</a>
                </li>
                <li :class="[activeIndex == 5?'navItem on':'navItem']">
                  <a href="javascript:;" title="Third Item"  @click="news" data-nav="5">新闻中心</a>
                </li>
<!--                <li :class="[activeIndex == 6?'navItem on':'navItem']">-->
<!--                  <a href="javascript:;" title="Third Item" @click="news" data-nav="6">千界资讯</a>-->
<!--                </li>-->
                <li :class="[activeIndex == 7?'navItem on':'navItem']">
                  <a href="javascript:;" title="Third Item" @click="about" data-nav="7">关于辰图</a>
<!--                  <ul class="navContent">-->
<!--                    <li>-->
<!--                      <ul>-->
<!--                        <li><a class="second-a" href="javascript:;" @click="about" data-nav="7">公司简介</a></li>-->
<!--                      </ul>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <ul>-->
<!--                        <li><a class="second-a" href="javascript:;" @click="contact" data-nav="7">联系我们</a></li>-->
<!--                      </ul>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <ul>-->
<!--                        <li><a class="second-a" href="javascript:;" @click="join" data-nav="7">加入我们</a></li>-->
<!--                      </ul>-->
<!--                    </li>-->
<!--                  </ul>-->
                </li>
              </ul>
            </nav>
          </div>
          <div class="phone"><i class="icon iconfont">&#xe61b;</i>0551-65310687</div>
<!--          <div class="heasPCbtn" @click="showSearch"><button type="button"></button></div>-->
<!--          <div class="heasPCbtnbox rd5" v-if="searchShow">-->
<!--            <em class="heasPCbtn1" @click="showSearch">取消</em>-->
<!--            <span>-->
<!--              <button type="button" class="dj2" @click="search" data-nav="2"></button>-->
<!--              <input type="text" name="q1" id="q" value="" placeholder="填写关键词" v-model="keywords">-->
<!--            </span>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <!-- 手机头部 -->
    <div class="headMOB">
      <a href="./" class="logo">
        <img :src="img_url + configList.pc_logo" alt="logo">
      </a>
      <div class="headMOBR">
        <div :class="[mobileNavShow?'menubtn on':'menubtn']" @click="showMobileNav">
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>
      <div class="inav colorfff" style="display: block;" v-if="mobileNavShow">
        <dl>
          <dt class="on"><a href="javascript:;" @click="home" data-nav="1">首页</a></dt>
          <dt class="">
            <a href="javascript:;" @click="service" data-id="1" data-nav="3">产品服务</a>
            <em :class="[navSolutionShow?'act':'']" @click="showNavSolution">＋</em>
          </dt>
          <dd v-for="(item,index) in solutionCateList" :key="index">
            <a href="javascript:;" v-if="navSolutionShow" @click="service" data-type="solution" :data-id="item.id" :data-name="item.name" data-nav="3">{{item.name}}</a>
          </dd>
          <dt>
            <a href="javascript:;" title="Second Item" @click="solution" data-id="26" data-name="解决方案" data-nav="2">解决方案</a>
            <em :class="[navServiceShow?'act':'']" @click="showNavService">＋</em>
          </dt>
          <dd v-for="(item,index) in cateList" :key="index">
            <a href="javascript:;" v-if="navServiceShow" @click="solution" data-type="service" :data-id="item.id" :data-name="item.name" data-nav="2">{{item.name}}</a>
          </dd>
          <dt>
            <a href="javascript:;" @click="join" data-nav="4">人才招聘</a>
            <em>＋</em>
          </dt>
          <dd></dd>
          <dt>
            <a href="javascript:;" @click="news" data-nav="5">新闻中心</a>
            <em>＋</em>
          </dt>
          <dd></dd>
          <dt>
            <a href="javascript:;" title="Third Item" @click="about" data-nav="7">关于辰图</a>
            <em>＋</em>
          </dt>
        </dl>
      </div>
    </div>
    <!-- 轮播图 -->
<!--    <div class="banner">-->
<!--      <swiper class="swiper" :options="swiperOption" ref="mySwiper">-->
<!--        <swiper-slide v-for="(item,index) in dataList" :key="index" :style="item.background">-->
          <!-- <img class="swiper-image" :src="base_url+item.imgUrl"> -->
          <!-- 轮播内容 -->
<!--          <div class="banner-table">-->
<!--            <div class="cell">-->
<!--              <div class="blockbox">-->
<!--                <h1>CYBERARK<br>Gartner特权访问管理魔力象限领导者</h1>-->
<!--                <p>特权账号管理（PAM）是Gartner2019年十大安全项目之首，CyberArk是该领域值得信赖的领导者</p>-->
<!--                <span class="btn btn4"><font>了解更多</font> <i></i></span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </swiper-slide>-->
<!--        <div class="swiper-pagination" slot="pagination"></div>-->
<!--        <a class="swiper-button-prev" slot="button-prev" @click="prev"></a>-->
<!--        <a class="swiper-button-next" slot="button-next" @click="next"></a>-->
<!--      </swiper>-->
<!--    </div>-->
  </div>
</template>

<script>
  import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
  import 'swiper/swiper-bundle.css';
  var axios = require('axios');
  var CONFIG = require('@/common/config.js');
  var base_url = CONFIG.API_URL.BASE_URL;
  var img_url = CONFIG.API_URL.IMG_URL;
  export default {
    name: 'swiper-example-navigation',
    components: {
      Swiper,
      SwiperSlide
    },
    data () {
      return {
        base_url: base_url,
        img_url: img_url,
        configList: [],
        activeIndex: '4',
        mobileNavShow: false,//手机端导航展示
        solutionCateList: [],//解决分类列表
        cateList: [],
        navSolutionShow: false,//手机端解决方案导航展示
        navServiceShow: false,//手机端解决方案导航展示
        navAboutShow: false,//手机端关于我们导航展示
        searchShow: false,//搜索栏展示
        keywords: '',//关键词
        dataList: [],
        swiperOption: {
          loop: true,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
            observer: true,
            observeParents: true
          },
          // 显示分页
          pagination: {
            el: '.swiper-pagination'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    created () {
      var that = this;

      //获取导航标识
      that.getNavStorage();

      //获取解决分类列表
      that.getSolutionCateList();

      that.getCateList();
      // 获取轮播图
      that.getSlideList()

      that.getConfigList()
    },
    destroyed() {
      var that = this;
      localStorage.removeItem('navIndex');
    },
    methods: {
      //获取导航标识
      getNavStorage:function(){
        var that = this;
        var navIndex = localStorage.getItem('navIndex');
        //console.log(navIndex);
        if(parseFloat(navIndex).toString() != "NaN"){
          that.activeIndex = navIndex;
        }else{
          that.activeIndex = '1';
        }
      },

      //显示搜索
      showSearch:function(){
        var that = this;
        var searchShow = that.searchShow;
        if(searchShow){
          that.searchShow = false;
        }else{
          that.searchShow = true;
        }
      },

      //获取配置信息
      getConfigList:function(){
        var that = this;
        axios.post(base_url+'front/getConfigList', {'group': null}).then(function (res) {
          // console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            var configList = [];
            for (var i=0;i<dataList.length;i++) {
              var itemKey = dataList[i]['itemKey'];
              var itemValue = dataList[i]['itemValue'];
              configList[itemKey] = itemValue;
            }
            that.configList = configList;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

      //展示手机端菜单
      showMobileNav:function(){
        var that = this;
        var show = that.mobileNavShow;
        if(show){
          that.mobileNavShow = false;
        }else{
          that.mobileNavShow = true;
        }
      },

      //获取服务分类列表
      getSolutionCateList:function(){
        var that = this;
        axios.post(base_url+'front/getInfoCateList', {'type': 1}).then(function (res) {
          //console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            // console.log(dataList)
            that.solutionCateList = dataList;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

      //获取解决分类列表
      getCateList:function(){
        var that = this;
        axios.post(base_url+'front/getInfoCateList', {'type': 2}).then(function (res) {
          //console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            // console.log(dataList)
            that.cateList = dataList;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

      //展示解决方案手机端菜单
      showNavSolution:function(){
        var that = this;
        var show = that.navSolutionShow;
        if(show){
          that.navSolutionShow = false;
        }else{
          that.navSolutionShow = true;
        }
      },

      //展示服务支持手机端菜单
      showNavService:function(){
        var that = this;
        var show = that.navServiceShow;
        if(show){
          that.navServiceShow = false;
        }else{
          that.navServiceShow = true;
        }
      },

      //展示关于我们手机端菜单
      showNavAbout:function(){
        var that = this;
        var show = that.navAboutShow;
        if(show){
          that.navAboutShow = false;
        }else{
          that.navAboutShow = true;
        }
      },

      //二级导航详情
      navDetail:function(e){
        var that = this;
        var type = e.currentTarget.dataset.type;
        var id = e.currentTarget.dataset.id;
        if(type == "solution"){//解决方案
          var name = e.currentTarget.dataset.name;
          that.$router.push({ path: '/solution?service='+id+'&name='+name });

        }else if(type == "service"){//服务支持
          that.$router.push({ path: '/service?service='+id });

        }else if(type == "case"){//客户案例
          that.$router.push({ path: '/case' });

        }else if(type == "about"){//公司简介
          that.$router.push({ path: '/about' });

        }else if(type == "contact"){//联系我们
          that.$router.push({ path: '/contact' });

        }else if(type == "join"){//加入我们
          that.$router.push({ path: '/join' });

        }
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },

      //搜索
      search:function(e){
        var that = this;
        var keywords = that.keywords;
        console.log(keywords);
        that.$router.push({ path: '/solution?service=1&name='+keywords });
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },

      home (e) {
        this.$router.push({ path: './' });
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      solution (e) {
        var id = e.currentTarget.dataset.id;
        var name = e.currentTarget.dataset.name;
        this.$router.push({ path: '/solution',query:{id:id,name:name}});
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      service (e) {
        var that = this
        var id = e.currentTarget.dataset.id;
        this.$router.push({path:'/service',query:{id:id}});
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      cases (e) {
        this.$router.push({ path: '/cases' });
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      partner (e) {
        this.$router.push({ path: '/partner' });
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      news (e) {
        this.$router.push({ path: '/news' });
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      about (e) {
        this.$router.push({ path: '/about' });
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      contact (e) {
        this.$router.push({ path: '/contact' });
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      join (e) {
        this.$router.push({ path: '/join' });
        //储存导航标识
        var nav = e.currentTarget.dataset.nav;
        localStorage.setItem("navIndex",nav);
      },
      prev () {
        this.$refs.mySwiper.$swiper.slidePrev()
      },
      next () {
        this.$refs.mySwiper.$swiper.slideNext()
      },
      getSlideList () {
        var that = this
        axios.post(base_url+'front/getSlideList', {'type': 1}).then(function (res) {
          var result = res.data.result
          for (var i = 0; i < result.length; i++) {
            var data = []
            data['imgUrl'] = result[i]['imgUrl']
            data['title'] = result[i]['name']
            // that.dataList[i]['text'] = result[i]['text']
            data['solution_id'] = result[i]['id']
            data['background'] = "background: url("+img_url+result[i]['imgUrl']+") center center no-repeat;";
            that.dataList.push(data)
          }
        }).catch(function (err) {
          //console.log(err)
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../css/iconfont.css";
  @import url("header.css");
</style>



// WEBPACK FOOTER //
// src/views/inner/header/header.vue